import React, { useState, useEffect, useRef } from 'react';
import './App.scss';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import { io } from 'socket.io-client';
import queryString from 'query-string';

import { useSelector, useDispatch } from 'react-redux';

import AppBar from './components/AppBar/indexAdd';
import AppBarMobile from './components/AppBar/Mobile';
import TopBar from './components/AppBar/Topbar';
// import RightBar from './components/AppBar/RightBar';

import ScrollToTop from './components/ScrollToTop/Index';

// import SingleProfile from './pages/SingleProfile/Master';
import MyBiyesadiMaster from './pages/MyBiye/Master';
import MatchesMaster from './pages/Matches/Master';
import SearchMaster from './pages/Search/Master';
import ConnectionMaster from './pages/Connection/Master';
import TimelineMaster from './pages/Timeline/Master';
import Messanger from './pages/Messanger/Index';
import FourOFour from './pages/FourOfour/Index';

import OptionContextProvider from './utils/context/optionContext';
import UserContextProvider from './utils/context/userContext';
import SingleProfileContextProvider from './utils/context/SingleProfileContext';
import RefineSearchContext from './utils/context/RefineSearchContext';

import Icon from 'react-icons-kit';
import { chevronUp } from 'react-icons-kit/feather';

import { arrivalMessageSetter } from './utils/Redux/Slice/Chat/ArraivalMessageSlice';
import { onlineUsersSetter } from './utils/Redux/Slice/Chat/OnlineUserSlice';
import { doRefatch } from './utils/Redux/Slice/RefatchSlice';
import {
  incomingProposal,
  acceptedProposal,
  doProfileViewed
} from './utils/Redux/Slice/NotificationSlice';

// toast.configure({ autoClose: 2000 });

function App() {
  const socket = useRef(null);
  const dispatch = useDispatch();

  const userID = useSelector((state) => state.user.userData.userID);
  const [isVisible, setIsVisible] = useState(false);

  const query = queryString.parse(window.location.search);

  let token = localStorage.getItem('token');
  if (!token && query.token) {
    token = query.token;
    localStorage.setItem('token', query.token);
  }

  // socket init
  useEffect(() => {
    socket.current = io(process.env.REACT_APP_API_URL, {
      transports: ['websocket', 'polling'],
    });
  }, []);

  // online users
  useEffect(() => {
    if (!userID) return;

    socket.current.emit('addUser', userID);
    socket.current.on('onlineUsers', (users) => {
      if (users?.length) {
        dispatch(onlineUsersSetter(users));
      }
    });
  }, [userID, dispatch]);

  // socket events
  useEffect(() => {
    if (!socket.current) return;

    socket.current.on('getMessage', (data) => {
      const payload = {
        sender: data.senderId,
        text: data.text,
        messageImage: data.messageImage,
        createdAt: Date.now(),
      };
      dispatch(arrivalMessageSetter(payload));
    });

    socket.current.on('sendProposalAlert', ({ name }) => {
      toast.success(`${name} send you a proposal`);
      dispatch(incomingProposal());
      if (window.location.pathname === '/connection/pending') {
        dispatch(doRefatch());
      }
    });

    socket.current.on('acceptProposalAlert', ({ name }) => {
      toast.success(`${name} accepted your proposal`);
      dispatch(acceptedProposal());
      if (window.location.pathname === '/connection') {
        dispatch(doRefatch());
      }
    });

    socket.current.on('profileViewedAlert', (data) => {
      dispatch(doProfileViewed(data));
    });

  }, [dispatch]);

  // scroll to top button
  useEffect(() => {
    const listenToScroll = () => {
      setIsVisible(window.scrollY > 700);
    };
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const gotoTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!token) {
    setTimeout(() => {
      window.location.replace(process.env.REACT_APP_BIYESADI_URL);
    }, 3000);

    return (
      <div className="text-center py-4">
        <p>You have to login first.</p>
        <p>Redirecting after 3s...</p>
      </div>
    );
  }

  return (
    <div className="App">
      {isVisible && (
        <button className="upBtn shadow-none d-none d-lg-block" onClick={gotoTop}>
          <Icon icon={chevronUp} size={20} />
        </button>
      )}

      <OptionContextProvider>
        <UserContextProvider>
          <SingleProfileContextProvider>
            <RefineSearchContext>
              
              <Router>
                <ScrollToTop>
                  <div className='d-block d-lg-none'>
                    <AppBarMobile/>
                  </div>
                  
                  <div className="dashboard-container">
                    <aside className="left-sidebar d-none d-lg-block">
                      <AppBar />
                      
                    </aside>

                    <main className="main-content">
                      <div className='d-none d-lg-block'>
                        <TopBar />
                      </div>
                      
                      <Routes>
                        <Route path="/" element={<Navigate to="/my-ghotokbari" />} />
                        <Route path="/my-ghotokbari/*" element={<MyBiyesadiMaster />} />
                        <Route path="/matches/*" element={<MatchesMaster />} />
                        <Route path="/search/*" element={<SearchMaster />} />
                        <Route path="/connection/*" element={<ConnectionMaster />} />
                        <Route path="/timeline/*" element={<TimelineMaster />} />
                        <Route path="/messanger" element={<Messanger />} />
                        <Route path="*" element={<FourOFour />} />
                      </Routes>
                    </main>

                    {/* <aside className="right-sidebar d-none d-lg-block">
                      <h4>Say Hello Today!!!</h4>
                      <RightBar />
                    </aside> */}
                  </div>

                </ScrollToTop>
              </Router>

            </RefineSearchContext>
          </SingleProfileContextProvider>
        </UserContextProvider>
      </OptionContextProvider>
    </div>
  );
}

export default App;
